export default "__VITE_ASSET__DNR3CtNg__"